/* PACKAGES */
import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button, Collapse } from "@material-tailwind/react";

/* ICONS */
import { IoMdMenu } from "react-icons/io";

/* NAVIGATION LINKS */
const navigationLinks = [
  {
    id: 1,
    route: "/",
    name: "Home",
  },
  {
    id: 2,
    route: "/about-us",
    name: "About Us",
  },
  {
    id: 3,
    route: "/pricing",
    name: "Pricing",
  },
];

const Header = () => {
  /* LOCATION */
  const location = useLocation();

  /* COLLAPSE MENU */
  const [collapseMenu, setCollapseMenu] = useState(false);

  return (
    <header className="relative z-50 bg-white py-3 header-shadow">
      <div className="container">
        <div className="flex items-center justify-between">
          {/* LOGO */}
          <Link href="/" className="w-fit block">
            <img
              src={require("../assets/images/logo.png")}
              className="w-auto h-14 object-contain"
              alt="Alumni Connection Hub"
            />
          </Link>

          {/* NAVIGATION LINKS */}
          <div className="hidden xl:flex lg:flex items-center gap-10">
            {navigationLinks.map((data) => (
              <Link
                key={data.id}
                to={data.route}
                className={`block relative ${
                  location.pathname === data.route ? "text-logo" : "text-black"
                } hover:text-logo font-ibm-semibold text-base transition-all duration-300 ease-in-out`}
              >
                {data.name}

                {location.pathname === data.route && (
                  <div className="absolute -bottom-1.5 left-0 w-full">
                    <div className="w-full h-[0.3vh] bg-logo rounded-full" />
                  </div>
                )}
              </Link>
            ))}

            <a
              href="https://calendly.com/roundtechsquare/new-meeting"
              target="_blank"
              rel="noreferrer"
              className="block"
            >
              <Button className="shadow-none hover:shadow-none bg-logo hover:bg-opacity-70 transition-all duration-300 ease-in-out text-base font-medium font-source text-white normal-case">
                Schedule a demo
              </Button>
            </a>
          </div>

          {/* MENU BUTTON */}
          <Button
            className="block xl:hidden lg:hidden shadow-none hover:shadow-none bg-white border border-greyBorder rounded-full p-2.5"
            onClick={() => setCollapseMenu(!collapseMenu)}
          >
            <IoMdMenu className="w-5 h-5 text-greyText" />
          </Button>
        </div>
      </div>

      {/* MOBILE MENU */}
      <Collapse
        open={collapseMenu}
        placement="bottom"
        animate={{
          mount: { opacity: 1, y: 0 },
          unmount: { opacity: 0, y: 25 },
        }}
        className="mt-2"
      >
        <div className="p-5 border-t border-greyBorder">
          <Link
            to="/"
            className="block text-base font-lato-bold text-black custom-underline"
            onClick={() => setCollapseMenu(!collapseMenu)}
          >
            Home
          </Link>
          <Link
            to="/about-us"
            className="block text-base font-lato-bold text-black custom-underline mt-5 xl:mt-0 lg:mt-0"
            onClick={() => setCollapseMenu(!collapseMenu)}
          >
            About us
          </Link>
          <Link
            to="/pricing"
            className="block text-base font-lato-bold text-black custom-underline mt-5 xl:mt-0 lg:mt-0"
            onClick={() => setCollapseMenu(!collapseMenu)}
          >
            Pricing
          </Link>
          <a
            href="https://calendly.com/roundtechsquare/new-meeting"
            target="_blank"
            rel="noreferrer"
            className="block mt-5"
          >
            <Button className="shadow-none hover:shadow-none bg-logo hover:bg-opacity-70 transition-all duration-300 ease-in-out text-base font-medium font-source text-white normal-case">
              Schedule a demo
            </Button>
          </a>
        </div>
      </Collapse>
    </header>
  );
};

export default Header;
